import { api } from "../lib/api";
import { useAuthStore } from "../stores/auth.store";
import { Role } from "@mestergo/shared";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { useLocale } from "../lib/i18n";
import { useNavigate, useLocation } from "react-router-dom";

export function RoleChooserPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchUser } = useAuthStore();
  const { t } = useLocale();

  const chooseRole = async (role: Role) => {
    await api.post("/users/me/role", { role });
    await fetchUser();

    const currentPath = location.pathname;
    if (role === Role.Handyman) {
      const destination = currentPath.startsWith("/handyman/") ? currentPath : "/handyman/profile";
      navigate(destination, { replace: true });
    } else {
      const destination = currentPath === "/request" ? "/request" : "/";
      navigate(destination, { replace: true });
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <div className="flex justify-end p-4">
        <LanguageSwitcher />
      </div>

      <div className="flex-1 flex flex-col justify-center px-6 pb-10">
        <div className="mb-10">
          <div className="text-3xl font-bold text-gray-900 leading-tight">{t.welcomeToMesterin}</div>
          <div className="mt-2 text-base text-gray-500">{t.howUsingApp}</div>
        </div>

        <div className="space-y-4">
          {/* Client */}
          <button
            onClick={() => chooseRole(Role.Client)}
            className="w-full rounded-2xl bg-gray-900 px-6 py-5 text-left text-white active:bg-gray-800 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 text-xl">
                🔧
              </div>
              <div>
                <div className="text-lg font-bold">{t.needService}</div>
                <div className="text-sm font-normal opacity-70 mt-0.5">{t.needServiceHint}</div>
              </div>
            </div>
          </button>

          {/* Handyman */}
          <button
            onClick={() => chooseRole(Role.Handyman)}
            className="w-full rounded-2xl bg-orange-500 px-6 py-5 text-left text-white active:bg-orange-600 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 text-xl">
                👷
              </div>
              <div>
                <div className="text-lg font-bold">{t.offerServices}</div>
                <div className="text-sm font-normal opacity-70 mt-0.5">{t.offerServicesHint}</div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
